var $customerOrders;
var ordersXhr;

function decodeQueryString(qs) {
  return JSON.parse('{"' + qs.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
    function(key, value) {
      return key === "" ? value : decodeURIComponent(value);
    }
  );
}

function searchCustomerOrders() {
  var data = {};

  var search = window.location.search.substring(1);

  if(search !== '') {
    data = decodeQueryString(search);
  }

  $customerOrders.fadeTo(1, .35);

  ordersXhr = $.ajax({
    cache: false,
    data: data,
    dataType: 'html',
    method: 'GET',
    url: '/service/fetch-orders'
  })
    .fail(function(xhr) {
      $customerOrders.prependAlert("We are having trouble retrieving your orders. If you continue to receive this error, please let us know.");
    })
    .done(function(response) {
      $customerOrders.html(response);
    })
    .always(function() {
      $customerOrders.fadeTo(1, 1);

      if(window.scrollY <= $customerOrders.offset().top) {
        return;
      }

      if(!window.scroll) {
        $customerOrders.scrollIntoView(true);

        return;
      }

      window.scroll({
        top: $customerOrders.offset().top - 50,
        behavior: 'smooth',
      });
    });
}

$(function() {

  $customerOrders = $('#customer-orders');

  if($customerOrders.length === 1) {
    searchCustomerOrders();

    $customerOrders.on('click', '.customer-orders-nav', function(event) {
      if(window.history.pushState) {
        event.preventDefault();

        var index = event.target.href.indexOf('?');
        var qs = index >= 0 ? event.target.href.substring(index + 1) : '';
        var state = decodeQueryString(qs);

        window.history.pushState(state, '', '?' + qs);

        $customerOrders.append('<div class="cover-loader"><div class="loading-spinner is-spinning"></div></div>');

        searchCustomerOrders();
      }
    });
  }

});